// Administrator appearance is separate from the customer's existing preference.
export const THEME_KEY = 'fanbird-theme';
const LEGACY_KEY = 'fanbird.appearance';
const CHANGE_EVENT = 'fanbird:themechange';

export function getTheme() {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

export function readThemePreference() {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
    // Copy a previous explicit choice once; never change the customer's key.
    const legacy = localStorage.getItem(LEGACY_KEY);
    if (legacy === 'light' || legacy === 'dark') {
      try { localStorage.setItem(THEME_KEY, legacy); } catch { /* Session only. */ }
      return legacy;
    }
  } catch { return getTheme(); }
  return 'dark';
}

function applyTheme(theme) {
  const next = theme === 'light' ? 'light' : 'dark';
  document.documentElement.dataset.theme = next;
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: next }));
  return next;
}

export function initializeTheme() {
  return applyTheme(readThemePreference());
}

export function setTheme(theme) {
  const next = applyTheme(theme);
  try { localStorage.setItem(THEME_KEY, next); } catch { /* Session only. */ }
  return next;
}

export function toggleTheme() {
  return setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

export function subscribeTheme(onChange) {
  const onStorage = (event) => {
    if (event.key !== THEME_KEY && event.key !== null) return;
    if (!document.documentElement.hasAttribute('data-admin-design')) return;
    initializeTheme();
  };
  window.addEventListener(CHANGE_EVENT, onChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange);
    window.removeEventListener('storage', onStorage);
  };
}
